import React from 'react';
import {connect} from "react-redux";
import {withStyles} from '@material-ui/core/styles';
import Ribform from "./Ribform.jsx"
import styles from "./customMaterialUIStyle"

@connect(store => {
	return {
  customer: store.customer.customer,
  validateIbanAndBic: store.customer.status || "",
  messageError: store.customer.message || "",
  showDocumentSignModal:store.customer.showDocumentSignModal,
  openRedirect: store.customer.openRedirect
}})

class PaymentMethodDialog extends React.Component {

render() {
  const {open, paymentMethod,customerAccount,offer,userAccount,subscription} = this.props;
 
  return (
    <div class="text-center">
        <Ribform offer={offer} subscription={subscription} customerAccount={customerAccount} open={open} paymentMethod={paymentMethod} userAccount={userAccount}/>
    </div>
    );
  }
}
export default withStyles(styles)(PaymentMethodDialog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/PaymentMethodDialog.jsx